/**
 * Canonical buyer-facing names for the three company tiers.
 *
 * The DB enum is `standard | premium | luxury`, but everywhere a buyer
 * sees a tier it must read Thoughtful / Impressive / Unforgettable. This
 * is the single source of truth so the Dashboard, Approval modal,
 * Settings, and the vendor pickers never drift (the audit found a bakery
 * picker showing "Premium" while the default-tier select said
 * "Impressive", and the Dashboard hardcoding "Thoughtful tier" regardless
 * of the real tier).
 */

export type CompanyTier = "standard" | "premium" | "luxury";

export const TIER_LABELS: Record<CompanyTier, string> = {
  standard: "Thoughtful",
  premium: "Impressive",
  luxury: "Unforgettable",
};

export function isCompanyTier(value: unknown): value is CompanyTier {
  return value === "standard" || value === "premium" || value === "luxury";
}

/**
 * Buyer-facing label for a tier. Falls back to "Thoughtful" for null /
 * unknown values, matching the unset-tier default used by the engine.
 */
export function tierLabel(tier: string | null | undefined): string {
  return isCompanyTier(tier) ? TIER_LABELS[tier] : "Thoughtful";
}
